import { defineCustomElement, ref, onMounted, computed, watch } from 'vue/dist/vue.esm-bundler.js'
import { html } from './shared/functions'

// 폼에서 require를 나타는 * 장식
const TcLabelAstar = defineCustomElement({
  props: {},
  setup() {},
  template: html`
  <span class="text-xl text-red-500 dark:text-red-400">*</span>
`,
},  { shadowRoot: false })

// 목록 아이템을 > 로 장식
const TcListArrow = defineCustomElement({
  props: {},
  setup() {},
  template: html`
  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 3l4 5-4 5"></path>
  </svg>
`,
},  { shadowRoot: false })

customElements.define('tc-label-astar', TcLabelAstar)
customElements.define('tc-list-arrow', TcListArrow)
